export default __webpack_public_path__ + "static/usefulimg-dea26cf2e59e0bcd456155b797eaa502.svg";